import { useLocation } from 'react-router-dom';

import { ReactComponent as Alert } from 'assets/icons/alert-icon.svg';
import groupImg from 'assets/images/group-2.jpg';
import stageClipLogo from 'assets/images/stage-clip-logo.png';
import { useLocale } from 'hooks/useLocale/useLocale';
import { Card, Typography } from 'ui/atoms';

import { useStyles } from './NoNameList.style';

export const NoNameList = () => {
  const styles = useStyles();
  const { state } = useLocation();
  const { formatMessage } = useLocale();

  return (
    <div className={styles.root}>
      <div className={styles.cardContainer}>
        <div className={styles.stageClipLogo}>
          <img src={stageClipLogo} alt="Logo" />
        </div>
        <div className={styles.content}>Find My Clip</div>
        <Card className={styles.card}>
          <div className={styles.icon}>
            {/* <EmailIcon /> */}
            <Alert />
          </div>
          <Typography className={styles.systemStatus}>System Status</Typography>

          <Typography className={styles.emailTitle}>{formatMessage({ id: 'clip.Waiting.Assets.title' })}</Typography>

          <Typography className={styles.emailDescription}>
            {`Hello! ${state.data?.fullName}!`} <span className={styles.overrideColor}> 🌼 </span>
          </Typography>
          <Typography className={styles.secondParagraph}>
            {`We have your ceremony footage, but we are waiting on final graduate data from your institution. `}
            <span className={styles.overrideColor}> 🎬✨ </span>
            {`Once we get it we’ll send your special moment by email.`}
            {!state.data?.isEventVideoInclude &&
            (!state.data?.isThemeSelected || !state.data?.eventData?.isIncludeParticipant) ? (
              <>
                {`video footage and data from your institution.`}
                <span className={styles.overrideColor}> 🎬✨ 🎬✨ </span>
              </>
            ) : !state.data?.isEventVideoInclude ? (
              <>
                {`video footage from your institution.`}
                <span className={styles.overrideColor}> 🎬✨ </span>
              </>
            ) : null}
            {state.data?.publicationType === 'AsSoonAsClipAreReady' && <>(publication status – ‘when ready’!)</>}
            {state.data?.publicationDateAndTime !== null && (
              <>(on {state.data?.publicationDateAndTime} as requested by your institution)!</>
            )}
            <span className={styles.overrideColor}> 🌟🎥 </span>
            {state.data.portalUrl && state.data.clipSearchEnable && (
              <>
                You can also pop back{' '}
                <a
                  className={styles.clipLink}
                  href={state.data?.portalUrl ? state.data?.portalUrl : ''}
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>{' '}
                to catch the excitement! <span className={styles.overrideColor}> 💌 </span>
              </>
            )}
          </Typography>
          <div>
            <Typography className={styles.differentEmail}>
              {formatMessage({ id: 'clip.not.available.different.email' })}
              <br />
              {formatMessage({ id: 'clip.raise.ticket' })}
            </Typography>
          </div>
          <div>
            <a
              className={styles.linkTicket}
              href="https://stageclip.com/student-support/"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>
          </div>
        </Card>
      </div>

      <div className={styles.institutionContainer}>
        <Typography className={styles.clientText}>{formatMessage({ id: 'find.clips.institutions.title' })}</Typography>
        <div className={styles.imageContainer}>
          <img src={groupImg} alt="HeaderImage" className={styles.images} />
        </div>
      </div>
    </div>
  );
};
